import React from 'react';
import ContinentView from './ContinentView';
import { getCdnImageUrl } from '../utils/cdn';

import banner from '../assets/europe.jpg';
import italy from '../assets/italy.jpg';
import france from '../assets/france.jpg';
import monaco from '../assets/monaco.jpg';
import england from '../assets/england.jpg';
import iceland from '../assets/iceland.jpg';
import norway from '../assets/norway.jpeg';
import sweden from '../assets/sweden.jpg';

const destinations = [
  { name: 'Italy', region: 'Italy', image: italy },
  { name: 'France', region: 'France', image: france },
  { name: 'Monaco', region: 'Monaco', image: monaco },
  { name: 'England', region: 'England', image: england },
  { name: 'Iceland', region: 'Iceland', image: iceland },
  { name: 'Norway', region: 'Norway', image: norway },
  { name: 'Sweden', region: 'Sweden', image: sweden },
  { name: 'Greece', region: 'Greece', image: getCdnImageUrl('europe/greece/2026/greece.jpeg') },
  { name: 'Germany', region: 'Germany', image: getCdnImageUrl('europe/germany/sep2026/ger2026FR-2.JPEG') },
];

const Europe = () => (
  <ContinentView
    continentName="Europe"
    bannerImage={banner}
    description="Explore Europe with The Half Time Travel. Discover Italy, France, Monaco, England, Iceland, Norway, Sweden, Greece, and Germany."
    destinations={destinations}
  />
);

export default Europe;